import { useDispatch } from "react-redux";
import { Button } from "react-bootstrap";
import { getDocumentDownload } from "./ChatbotAxiosFuncs";
import { setGlobalErrorStatus } from "Components/StatusHandling";
import { ERROR_MESSAGES } from 'Utils/constants';
import { useState } from "react";

// Display the document download within the chat message
const ChatDocument = ({
  item
}) => {

  const dispatch = useDispatch();

  const [isDownloading, setIsDownloading] = useState(false);

  const handleFileDownloadByKey = (e, groupId) => {
    // Enter key code: 13
    if (e.keyCode == 13) {
      handleFileDownload(groupId);
    }
  }

  const handleFileDownload = async (groupId) => {

    setIsDownloading(true);

    const res = await getDocumentDownload(groupId).catch((error) => {
      //console.log("Error caught while loading data: " + error);
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: error
      });
      setIsDownloading(false);
    });

    if (res) {
      //console.log("handleFileDownload in the chatbot component", res);
      // get filename from the res content-disposition
      const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
      let url = window.URL.createObjectURL(res.data);
      let a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a); // append the element to the dom
      a.click();
      a.remove(); // afterwards, remove the element  
    } else {
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.GENERAL_ERROR.title,
          msg: ERROR_MESSAGES.GENERAL_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        }
      })
    }
    setIsDownloading(false);
  }

  return (
    <>
      {isDownloading ?
        <div
          className="mt-2 chatbot-message-additional-info"
        >
          {item.doc_name}
        </div> :
        <div>
          <Button
            className="m-0 p-0 mt-2 chatbot-message-additional-info text-start"
            onClick={() => handleFileDownload(item.groupId)}
            onKeyDown={(e) => handleFileDownloadByKey(e, item.groupId)}
          >
            {item.doc_name}
          </Button>
        </div>}
    </>
  )
}

export default ChatDocument;